
import React, { useEffect, useState, useRef } from "react";
import Flashcard from "./Flashcard";
import "./App.css";
import Particles from "react-tsparticles";
import Confetti from "react-confetti";
import { supabase } from "./supabase";
import logo from "./logo.png";


function FlashcardApp({ isAdmin, topic, onBack }) {
  console.log("FlashcardApp isAdmin =", isAdmin);

  const [flashcardPage, setFlashcardPage] = useState(1);

  const FLASHCARDS_PER_PAGE = 5;

  const [cards, setCards] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const ref = useRef(null);
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState("next");
  const [animating, setAnimating] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [editingCard, setEditingCard] = useState(null);
  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswer, setNewAnswer] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [insertAfter, setInsertAfter] = useState("end");
  const [draggedCardId, setDraggedCardId] = useState(null);
const [dragOverCardId, setDragOverCardId] = useState(null);

  // ===== Page Number Grouping =====
  const PAGES_PER_GROUP = 20;

  const currentGroup = Math.floor(index / PAGES_PER_GROUP);

  const startPage = currentGroup * PAGES_PER_GROUP;

  const endPage = Math.min(
    startPage + PAGES_PER_GROUP,
    cards.length
  );

  const filteredCards = cards.filter((card) => {
  const searchText = searchTerm.trim().toLowerCase();

  if (!searchText) return true;

  const question = card.question?.toLowerCase() || "";
  const answer = card.answer?.toLowerCase() || "";

  return (
    question.includes(searchText) ||
    answer.includes(searchText)
  );
});

const totalFlashcardPages = Math.ceil(
  filteredCards.length / FLASHCARDS_PER_PAGE
);

const flashcardStartIndex =
  (flashcardPage - 1) * FLASHCARDS_PER_PAGE;

const paginatedCards = filteredCards.slice(
  flashcardStartIndex,
  flashcardStartIndex + FLASHCARDS_PER_PAGE
);

  // ===== FETCH CARDS =====
  const fetchCards = async () => {
   const { data, error } = await supabase
  .from("flashcards")
  .select("*")
  .eq("topic", topic);
    console.log("DATA:", data);
    console.log("ERROR:", error);

    if (error) {
      console.error(error);
      return;
    }

    data.sort(
      (a, b) =>
        Number(a.card_number) - Number(b.card_number)
    );

    setCards(data);
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = 0;
    }
  }, [index]);

  // ===== ADD CARD =====
  const addCard = async () => {
    if (!newQuestion || !newAnswer) return;

    const nextCardNumber = cards.length + 1;

    const { data, error } = await supabase
      .from("flashcards")
      .insert([
        {
  card_number: nextCardNumber,
  question: newQuestion,
  answer: newAnswer,
  topic: topic,
}
      ])
      .select();

    console.log("DATA:", data);
    console.log("ERROR:", error);

    if (error) {
      alert(error.message);
      return;
    }

    alert("Card Added Successfully ✅");

    setNewQuestion("");
    setNewAnswer("");

    fetchCards();
  };

  // ===== DELETE CARD =====
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Delete this flashcard?"
    );

    if (!confirmDelete) return;

    const { error } = await supabase
      .from("flashcards")
      .delete()
      .eq("id", id);

    if (error) {
      alert(error.message);
      return;
    }

    alert("Flashcard deleted ✅");

    fetchCards();
  };

  // ===== UPDATE CARD =====
  const updateCard = async () => {
    const { error } = await supabase
      .from("flashcards")
      .update({
        question: newQuestion,
        answer: newAnswer,
      })
      .eq("id", editingCard.id);

    if (error) {
      alert(error.message);
      return;
    }

    alert("Flashcard updated ✅");

    setEditingCard(null);
    setNewQuestion("");
    setNewAnswer("");

    fetchCards();
  };

  const moveUp = async (index) => {
  if (index === 0) return;

  const updatedCards = [...cards];

  [updatedCards[index - 1], updatedCards[index]] = [
    updatedCards[index],
    updatedCards[index - 1],
  ];

  // Only change Manage Flashcards order
  setCards(updatedCards);

  const cardA = updatedCards[index - 1];
  const cardB = updatedCards[index];

  const { error: errorA } = await supabase
    .from("flashcards")
    .update({
      card_number: index + 1,
    })
    .eq("id", cardA.id);

  const { error: errorB } = await supabase
    .from("flashcards")
    .update({
      card_number: index + 2,
    })
    .eq("id", cardB.id);

  if (errorA || errorB) {
    console.error("Move Up error:", errorA || errorB);
    fetchCards();
  }
};

const moveDown = async (index) => {
  if (index === cards.length - 1) return;

  const updatedCards = [...cards];

  [updatedCards[index], updatedCards[index + 1]] = [
    updatedCards[index + 1],
    updatedCards[index],
  ];

  // Only change Manage Flashcards order
  setCards(updatedCards);

  const cardA = updatedCards[index];
  const cardB = updatedCards[index + 1];

  const { error: errorA } = await supabase
    .from("flashcards")
    .update({
      card_number: index + 1,
    })
    .eq("id", cardA.id);

  const { error: errorB } = await supabase
    .from("flashcards")
    .update({
      card_number: index + 2,
    })
    .eq("id", cardB.id);

  if (errorA || errorB) {
    console.error("Move Down error:", errorA || errorB);
    fetchCards();
  }
};

// ===== DRAG & DROP =====

const handleDragStart = (cardId) => {
  setDraggedCardId(cardId);
};

const handleDragOver = (e, cardId) => {
  e.preventDefault();

  if (cardId !== draggedCardId) {
    setDragOverCardId(cardId);
  }
};

const handleDragLeave = () => {
  setDragOverCardId(null);
};

const handleDrop = async (e, targetCardId) => {
  e.preventDefault();

  if (!draggedCardId || draggedCardId === targetCardId) {
    setDraggedCardId(null);
    setDragOverCardId(null);
    return;
  }

  const updatedCards = [...cards];

  const draggedIndex = updatedCards.findIndex(
    (card) => card.id === draggedCardId
  );

  const targetIndex = updatedCards.findIndex(
    (card) => card.id === targetCardId
  );

  if (draggedIndex === -1 || targetIndex === -1) {
    setDraggedCardId(null);
    setDragOverCardId(null);
    return;
  }

  // Remove dragged card
  const [draggedCard] = updatedCards.splice(
    draggedIndex,
    1
  );

  // Find target again after removing dragged card
  const newTargetIndex = updatedCards.findIndex(
    (card) => card.id === targetCardId
  );

  // Insert dragged card at target position
  updatedCards.splice(
    newTargetIndex,
    0,
    draggedCard
  );

  // Update question numbers locally
const reorderedCards = updatedCards.map((card, i) => ({
  ...card,
  card_number: i + 1,
}));

// Update screen immediately
setCards(reorderedCards);

// Save new order to Supabase
for (let i = 0; i < reorderedCards.length; i++) {
  const { error } = await supabase
    .from("flashcards")
    .update({
      card_number: i + 1,
    })
    .eq("id", reorderedCards[i].id);

  if (error) {
    console.error(
      "Drag & Drop order update error:",
      error
    );

    alert(
      "Could not save the new question order."
    );

    fetchCards();

    setDraggedCardId(null);
    setDragOverCardId(null);

    return;
  }
}

  setDraggedCardId(null);
  setDragOverCardId(null);
};

const handleDragEnd = () => {
  setDraggedCardId(null);
  setDragOverCardId(null);
};

  // ===== LOAD DATA =====
  useEffect(() => {
  if (topic) {
    setIndex(0);
    setFlashcardPage(1);
    setCompleted(false);
    fetchCards();
  }
}, [topic]);

  // ===== NEXT CARD =====
  const nextCard = () => {
    if (animating) return;

    if (index === cards.length - 1) {
      setCompleted(true);
      return;
    }

    setDirection("next");
    setAnimating(true);

    setTimeout(() => {
      setIndex((prev) => prev + 1);
      setAnimating(false);
    }, 250);
  };

  // ===== PREVIOUS CARD =====
  const prevCard = () => {
    if (animating) return;

    setDirection("prev");
    setAnimating(true);

    setTimeout(() => {
      setIndex((prev) => prev - 1);
      setAnimating(false);
    }, 250);
  };

  const goToFirst = () => setIndex(0);

  const goToLast = () => setIndex(cards.length - 1);

  // ===== RESTART =====
  const restart = () => {
    setIndex(0);
    setCompleted(false);
  };

  // ===== COMPLETED SCREEN =====
  if (completed) {
    return (
      <div style={styles.container}>
        <Confetti />

        <h1 style={styles.title}>Flashcards</h1>

        <div style={styles.progressBar}>
          <div
            style={{
              ...styles.progress,
              width: "100%",
            }}
          ></div>
        </div>

        <div style={styles.card}>
          <h2 style={{ color: "white" }}>
            🎉 Completed!
          </h2>

          <button
            style={styles.button}
            onClick={restart}
          >
            Restart 🔁
          </button>
        </div>
      </div>
    );
  }

  return (
 <div className="app">

  

  <Particles
    options={{
      particles: {
        number: { value: 60 },
        size: { value: 3 },
      },
    }}
  />

  <div className="topBanner">
    <img
      src={logo}
      alt="logo"
      className="bannerLogo"
    />
  </div>

  <button
    className="back-to-topics"
    onClick={onBack}
  >
    ← Back to Topics
  </button>
{/* ===== SEARCH BAR ===== */}
<div className="flashcard-search-wrapper">
  <div className="flashcard-search-box">

    <span className="flashcard-search-icon">
      🔍
    </span>

    <input
      type="text"
      className="flashcard-search-input"
      placeholder="Search questions or answers..."
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setFlashcardPage(1);
        setIndex(0);
      }}
    />

    {searchTerm && (
      <button
        className="flashcard-search-clear"
        onClick={() => {
          setSearchTerm("");
          setFlashcardPage(1);
          setIndex(0);
        }}
        aria-label="Clear search"
      >
        ×
      </button>
    )}

  </div>

  {searchTerm && (
    <div className="search-result-count">
      {filteredCards.length}{" "}
      {filteredCards.length === 1 ? "result" : "results"} found
    </div>
  )}
</div>

      {/* ===== ADMIN PANEL ===== */}
      {isAdmin && (
        <div
  style={{
    ...styles.adminContainer,
    position: "relative",
  }}
>
          <h2 style={styles.adminTitle}>
            Admin Panel
          </h2>

          {/* ADD / UPDATE FLASHCARD */}
          <div style={styles.adminCard}>
            <h3>
              {editingCard
                ? "Edit Flashcard"
                : "Add Flashcard"}
            </h3>

            <div style={styles.row}>
              {/* BIGGER QUESTION BOX */}
              <textarea
                placeholder="Question"
                value={newQuestion}
                onChange={(e) =>
                  setNewQuestion(e.target.value)
                }
                style={styles.textarea}
                rows={4}
              />

              {/* BIGGER ANSWER BOX */}
              <textarea
                placeholder="Answer"
                value={newAnswer}
                onChange={(e) =>
                  setNewAnswer(e.target.value)
                }
                style={styles.textarea}
                rows={6}
              />

              {editingCard ? (
                <button
                  onClick={updateCard}
                  style={styles.updateBtn}
                >
                  Update Card
                </button>
              ) : (
                <button
                  onClick={addCard}
                  style={styles.primaryButton}
                >
                  + Add Card
                </button>
              )}
            </div>
          </div>

          {/* ===== ALL QUESTIONS ===== */}
<div
  style={{
    position: "absolute",
    top: "80px",
    right: "-360px",
    width: "360px",
    background: "white",
    borderRadius: "12px",
    padding: "15px",
    boxSizing: "border-box",
    height: "800px",
    overflowY: "auto",
    boxShadow: "0 4px 15px rgba(0,0,0,0.25)",
    zIndex: 10,
  }}
>
  <h3
    style={{
      color: "#38499D",
      margin: "0 0 15px 0",
      textAlign: "center",
    }}
  >
    All Questions
  </h3>

 {cards.map((card, i) => (
  <div
    key={card.id}
    draggable
    onDragStart={() => handleDragStart(card.id)}
    onDragOver={(e) => handleDragOver(e, card.id)}
    onDragLeave={handleDragLeave}
    onDrop={(e) => handleDrop(e, card.id)}
    onDragEnd={handleDragEnd}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "8px",
      marginBottom: "6px",
      borderRadius: "6px",

      background:
        dragOverCardId === card.id
          ? "#d9f7ff"
          : "#f4f4f4",

      border:
        dragOverCardId === card.id
          ? "2px solid #00c2ff"
          : "1px solid #ddd",

      cursor: "grab",

      opacity:
        draggedCardId === card.id
          ? 0.5
          : 1,

      transition: "all 0.2s ease",
    }}
  >
    {/* DRAG ICON */}
    <span
      style={{
        fontSize: "18px",
        color: "#777",
        minWidth: "18px",
        cursor: "grab",
      }}
      title="Drag to reorder"
    >
      ⋮⋮
    </span>

    {/* QUESTION NUMBER */}
    <span
      style={{
        minWidth: "28px",
        height: "28px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#38499D",
        color: "white",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "13px",
      }}
    >
      {i + 1}
    </span>

    {/* QUESTION */}
    <span
      style={{
        color: "#222",
        fontSize: "13px",
        lineHeight: "1.3",
        flex: 1,
        overflowWrap: "anywhere",
      }}
    >
      {card.question}
    </span>
  </div>
))}
</div>

          {/* ===== MANAGE FLASHCARDS ===== */}
          <div style={styles.adminCard}>
            <h3>Manage Flashcards</h3>

            

            {paginatedCards.map((card, i) => (
              <div
                key={card.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                  padding: "14px",
                  marginBottom: "10px",
                  background:
                    "rgba(255,255,255,0.1)",
                  borderRadius: "8px",
                }}
              >
                {/* NUMBER + QUESTION */}
                <div
                  style={{
                    color: "white",
                    flex: 1,
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "1.5",
                    overflowWrap: "anywhere",
                  }}
                >
                  <span
                    style={styles.questionNumber}
                  >
                    {card.card_number}.
                  </span>{" "}
                  {card.question}
                </div>

               <div style={styles.actionButtons}>

  <button
    style={styles.editBtn}
    onClick={() => {
      setEditingCard(card);
      setNewQuestion(card.question);
      setNewAnswer(card.answer);
    }}
  >
    Edit
  </button>

  <button
    style={styles.deleteBtn}
    onClick={() => handleDelete(card.id)}
  >
    Delete
  </button>

</div>
              </div>
            ))}

            {/* PAGINATION */}
            <div
              style={{
                textAlign: "center",
                marginTop: "15px",
              }}
            >
              <button
                onClick={() =>
                  setFlashcardPage(
                    flashcardPage - 1
                  )
                }
                disabled={flashcardPage === 1}
                style={styles.pageBtn}
              >
                Prev
              </button>

              <span
                style={{
                  color: "white",
                  margin: "0 10px",
                  fontWeight: "bold",
                }}
              >
                {flashcardPage} /{" "}
                {totalFlashcardPages}
              </span>

              <button
                onClick={() =>
                  setFlashcardPage(
                    flashcardPage + 1
                  )
                }
                disabled={
                  flashcardPage ===
                  totalFlashcardPages
                }
                style={styles.pageBtn}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== FLASHCARD DISPLAY ===== */}
      <div
        className="card-container"
        ref={ref}
      >
        <h2 className="questionCounter">
          Question {index + 1} of {cards.length}
        </h2>

        <Flashcard
          key={cards[index]?.id}
          question={cards[index]?.question}
          answer={cards[index]?.answer}
          direction={direction}
          cardNumber={cards[index]?.card_number}
        />

        <div className="pageNumbers">
          {cards
            .slice(startPage, endPage)
            .map((_, i) => {
              const pageIndex = startPage + i;

              return (
                <button
                  key={pageIndex}
                  className={`pageBtn ${
                    pageIndex === index
                      ? "activePage"
                      : ""
                  }`}
                  onClick={() =>
                    setIndex(pageIndex)
                  }
                >
                  {pageIndex + 1}
                </button>
              );
            })}
        </div>

        <div className="buttons">
          <button
            onClick={goToFirst}
            disabled={index === 0}
          >
            ⏮ First
          </button>

          <button
            onClick={prevCard}
            disabled={index === 0}
          >
            ← Prev
          </button>

          <button onClick={nextCard}>
            {index === cards.length - 1
              ? "Complete ✅"
              : "Next →"}
          </button>

          <button
            onClick={goToLast}
            disabled={
              index === cards.length - 1
            }
          >
            Last ⏭
          </button>
        </div>
      </div>
    </div>
  );
}

// ===== STYLES =====



const styles = {
  container: {
    height: "100vh",
    background:
      "linear-gradient(135deg, #4b2cbf, #7a1fd1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    color: "white",
    marginBottom: "10px",
  },

  progressBar: {
    width: "60%",
    height: "6px",
    background: "#ccc",
    borderRadius: "10px",
    marginBottom: "30px",
  },

  progress: {
    height: "100%",
    background: "#00e0ff",
    borderRadius: "10px",
  },

  card: {
    background: "rgba(255,255,255,0.2)",
    padding: "40px",
    borderRadius: "15px",
    textAlign: "center",
    maxWidth: "600px",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
  },

  button: {
    marginTop: "20px",
    padding: "10px 20px",
    background: "black",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },

  adminContainer: {
    width: "100%",
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  adminTitle: {
    color: "white",
    marginBottom: "15px",
  },

  adminCard: {
    background: "rgba(255,255,255,0.15)",
    padding: "20px",
    borderRadius: "12px",
    marginBottom: "15px",
    backdropFilter: "blur(10px)",
  },

  row: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    alignItems: "stretch",
  },

  // BIGGER TEXTAREA STYLE
  textarea: {
    flex: "1 1 300px",
    width: "100%",
    minWidth: "0",
    minHeight: "130px",
    padding: "14px",
    fontSize: "16px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.5",
    borderRadius: "8px",
    border: "none",
    outline: "none",
    resize: "vertical",
    boxSizing: "border-box",
  },

  primaryButton: {
    padding: "10px 15px",
    borderRadius: "8px",
    border: "none",
    background: "#00d4ff",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bold",
    alignSelf: "center",
  },

  updateBtn: {
    background: "#4CAF50",
    color: "white",
    border: "none",
    padding: "10px 15px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    alignSelf: "center",
  },

  editBtn: {
    background: "#00c2ff",
    color: "black",
    border: "none",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },

  deleteBtn: {
    background: "#ff3b3b",
    color: "white",
    border: "none",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },

  pageBtn: {
    padding: "6px 12px",
    border: "none",
    borderRadius: "6px",
    background: "#00c2ff",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bold",
  },

 actionButtons: {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
  marginLeft: "20px",
  flexShrink: 0,
},

moveBtn: {
  width: "38px",
  height: "36px",
  padding: "0",
  background: "#00c2ff",
  color: "#000",
  border: "none",
  borderRadius: "7px",
  cursor: "pointer",
  fontSize: "18px",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
},

editBtn: {
  height: "36px",
  padding: "0 16px",
  background: "#00c2ff",
  color: "#000",
  border: "none",
  borderRadius: "7px",
  cursor: "pointer",
  fontWeight: "bold",
},

deleteBtn: {
  height: "36px",
  padding: "0 16px",
  background: "#ff3b3b",
  color: "#fff",
  border: "none",
  borderRadius: "7px",
  cursor: "pointer",
  fontWeight: "bold",
},

  // NUMBER BEFORE QUESTION
  questionNumber: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "28px",
    height: "28px",
    padding: "0 6px",
    marginRight: "6px",
    borderRadius: "6px",
    background: "#38499D",
    color: "white",
    fontWeight: "bold",
  },


  searchWrapper: {
  width: "100%",
  maxWidth: "1060px",
  margin: "4px auto 28px",
  padding: "0 20px",
  boxSizing: "border-box",
},

searchBox: {
  display: "flex",
  alignItems: "center",
  width: "100%",
  minHeight: "52px",
  padding: "0 14px",
  background: "rgba(255, 255, 255, 0.12)",
  border: "1px solid rgba(255, 255, 255, 0.35)",
  borderRadius: "14px",
  boxShadow: "0 6px 18px rgba(0, 0, 0, 0.12)",
  boxSizing: "border-box",
  transition: "all 0.2s ease",
},

searchIcon: {
  color: "#00d9f5",
  fontSize: "28px",
  fontWeight: "bold",
  lineHeight: "1",
  marginRight: "12px",
},

searchInput: {
  flex: 1,
  minWidth: 0,
  height: "48px",
  padding: "0 4px",
  border: "none",
  outline: "none",
  background: "transparent",
  color: "#ffffff",
  fontSize: "16px",
  fontWeight: "500",
  boxSizing: "border-box",
},

clearButton: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "30px",
  height: "30px",
  border: "none",
  borderRadius: "50%",
  background: "rgba(255, 255, 255, 0.22)",
  color: "#ffffff",
  fontSize: "22px",
  cursor: "pointer",
  lineHeight: "1",
},
};

export default FlashcardApp;